export default __webpack_public_path__ + "27dd89f84f9527dd8b79804167d6bf95.pdf";